import i18n from '../i18n';

const RESTRICTION_CODES = ['user_banned', 'user_restricted'];

// Returns { code, restriction, reason, expiresAt } for a 403 restriction error, otherwise null.
export const getRestriction = (error) => {
    const data = error?.response?.data;
    if (error?.response?.status !== 403 || !RESTRICTION_CODES.includes(data?.code)) return null;
    return data;
};

export const restrictionMessage = (t, restriction) => {
    const head = restriction.code === 'user_banned'
        ? t('errors.restricted.banned')
        : t(`errors.restricted.types.${restriction.restriction}`, { defaultValue: t('errors.restricted.generic') });
    const term = restriction.expiresAt
        ? t('errors.restricted.until', { date: new Date(restriction.expiresAt).toLocaleString(i18n.language) })
        : t('errors.restricted.permanent');
    return t('errors.restricted.message', { head, reason: restriction.reason, term });
};
